import Vue from 'vue'
import vuetify from '@/plugins/vuetify.js'
import AppLayout from './layout/AppIndex.vue'
import VueRouter from 'vue-router'
import { router } from './routes/router.js'
import store from './store/index.js'
import i18n from '@/i18n/index.js'
import Utils from '@/plugins/utils.js'
import authHelper from '@/helpers/authHelper.js'
import Mixins from '@/plugins/mixins.js'
import { GChart } from 'vue-google-charts/legacy'
import 'material-icons/iconfont/material-icons.css'

import directives from './plugins/directives'

Object.keys(directives).forEach((name) => {
  Vue.directive(name, directives[name])
})

Vue.use(VueRouter)
Vue.use(Utils)
Vue.use(authHelper)
Vue.use(Mixins)
Vue.use(GChart)

Vue.config.productionTip = false

const script = document.createElement('script')
script.src = 'https://www.gstatic.com/charts/loader.js'
script.async = true
document.head.appendChild(script)

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(AppLayout),
}).$mount('#app')
